import axiosClient from 'utils/axiosClient';
import api from 'api';

const getRoomBookings = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY.ROOM_BOOKINGS.ROOM_BOOKINGS, {params: data});
	return response.data;
};

const getRoomBookingsByID = async (id: any, data?: any) => {
	const response = await axiosClient.get(api.LIBRARY.ROOM_BOOKINGS.ROOM_BOOKINGS_BY_ID + id, data);
	return response.data;
};

const createRoomBooking = async (id: any, data: any) => {
	const response = await axiosClient.post(api.LIBRARY.ROOM_BOOKINGS.ROOM_BOOKINGS + 'booking', data);
	return response.data;
};

const updateRoomBooking = async (id: number, data: any) => {
	const response = await axiosClient.patch(api.LIBRARY.ROOM_BOOKINGS.ROOM_BOOKINGS_BY_ID + id, data);
	return response.data;
};

const deleteRoomBooking = async (id: any, data: any) => {
	const response = await axiosClient.patch(api.LIBRARY.ROOM_BOOKINGS.ROOM_BOOKINGS + id, {
		bookingStatusID: data.bookingStatusID
	});
	return response.data;
};

const getRoomBookingAuditLogs = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY.ROOM_BOOKINGS.ROOM_BOOKING_LOGS, {params: data});
	return response.data;
};

const service = {
	getRoomBookings,
	getRoomBookingsByID,
	createRoomBooking,
	updateRoomBooking,
	deleteRoomBooking,
	getRoomBookingAuditLogs
};

export default service;
